import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { select, Store } from '@ngrx/store';
import { Observable } from 'rxjs';
import { mergeMap, take } from 'rxjs/operators';
import { environment } from "../../environments/environment";
import { IStoreState } from '../store/store.state';
import { tokenSelector } from '../store/token/token.selectors';

@Injectable()
export class AuthInterceptor implements HttpInterceptor {
  constructor(private store: Store<IStoreState>) { }

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    return this.store.pipe(
      select(tokenSelector),
      take(1),
      mergeMap(token => {
        if (request.url.startsWith(environment.DASHBOARD_PRIVATE_BASE_URL)) {
          request = request.clone({
            setHeaders: {
              Authorization: `Dashboard ${token}`
            }
          });
        }
        return next.handle(request);
      }),
    );
  }
}
